namespace RioERP.Inventory {
    export interface PendriveInwardRow {
        Id?: number;
        PenDriveTypeId?: number;
        Qty?: number;
        Rate?: number;
        VendorId?: number;
        BillDocument?: string;
        Notes?: string;
        InwardDate?: string;
        IsActive?: boolean;
        PendriveType?: string;
        VendorName?: string;
        VendorDescription?: string;
        VendorBankName?: string;
        VendorBankAccountType?: number;
        VendorBankAccountName?: string;
        VendorBankAccountNo?: string;
        VendorBankIfscCode?: string;
        VendorAddress?: string;
        VendorCity?: string;
        VendorStateId?: number;
        VendorCountry?: string;
        VendorGstin?: string;
        VendorPan?: string;
        VendorGstCertificate?: string;
        VendorUserId?: number;
        VendorPincode?: number;
        VendorIsActive?: boolean;
        VendorInsertUserId?: number;
        VendorInsertDate?: string;
        VendorUpdateUserId?: number;
        VendorUpdateDate?: string;
        VendorEmail?: string;
        InsertUserId?: number;
        InsertDate?: string;
        UpdateUserId?: number;
        UpdateDate?: string;
    }

    export namespace PendriveInwardRow {
        export const idProperty = 'Id';
        export const nameProperty = 'PendriveType';
        export const localTextPrefix = 'Inventory.PendriveInward';
        export const deletePermission = 'Inventory:InventoryManagement:Modify';
        export const insertPermission = 'Inventory:InventoryManagement:Modify';
        export const readPermission = 'Inventory:InventoryManagement:View';
        export const updatePermission = 'Inventory:InventoryManagement:Modify';

        export declare const enum Fields {
            Id = "Id",
            PenDriveTypeId = "PenDriveTypeId",
            Qty = "Qty",
            Rate = "Rate",
            VendorId = "VendorId",
            BillDocument = "BillDocument",
            Notes = "Notes",
            InwardDate = "InwardDate",
            IsActive = "IsActive",
            PendriveType = "PendriveType",
            VendorName = "VendorName",
            VendorDescription = "VendorDescription",
            VendorBankName = "VendorBankName",
            VendorBankAccountType = "VendorBankAccountType",
            VendorBankAccountName = "VendorBankAccountName",
            VendorBankAccountNo = "VendorBankAccountNo",
            VendorBankIfscCode = "VendorBankIfscCode",
            VendorAddress = "VendorAddress",
            VendorCity = "VendorCity",
            VendorStateId = "VendorStateId",
            VendorCountry = "VendorCountry",
            VendorGstin = "VendorGstin",
            VendorPan = "VendorPan",
            VendorGstCertificate = "VendorGstCertificate",
            VendorUserId = "VendorUserId",
            VendorPincode = "VendorPincode",
            VendorIsActive = "VendorIsActive",
            VendorInsertUserId = "VendorInsertUserId",
            VendorInsertDate = "VendorInsertDate",
            VendorUpdateUserId = "VendorUpdateUserId",
            VendorUpdateDate = "VendorUpdateDate",
            VendorEmail = "VendorEmail",
            InsertUserId = "InsertUserId",
            InsertDate = "InsertDate",
            UpdateUserId = "UpdateUserId",
            UpdateDate = "UpdateDate"
        }
    }
}
